export default {"src":"/_next/static/media/submit-request.e5d3d70d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};